import { render } from "./lists.vue?vue&type=template&id=5fe765c0"
import script from "./lists.js?vue&type=script&lang=js"
export * from "./lists.js?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__